import React, {useEffect, useMemo, useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Valid from "../../../../../constants/Valid";
import {useForm} from "../../../../../components/Customs/useForm";
import Controls from "../../../../../components/Customs/Controls/Controls";
import {Card, CardContent, CardHeader, Container, Divider, Grid,} from '@material-ui/core';
import {useDispatch} from "react-redux";
import {getDataStatement} from "../../../../../store/Statement/actionStatement";
import {
  TRAINING_ALLOW_FOR_PAID,
  TRAINING_FACULTY,
  TRAINING_SPECIALITIES_GROUP,
  TRAINING_SPECIALITY_BUDGET,
  TRAINING_SPECIALITY_PAID,
  TRAINING_STUDY_FORM,
  TRAINING_STUDY_PAY,
  TRAINING_TARGET_RECRUITMENT,
  TRAINING_TARGET_RECRUITMENT_SPEC,
  TRAINING_TYPE,
} from "../../../../../services/tagTypes";
import GeneralBasis from "./generalBasis";
import TargetTraining from "./targetTraining";
import Olympiad from "./olympiad";
import PedagogicalSpecialties from "./pedagogicalSpecialties";
import SpecialtiesByTheEconomy from "./specialtiesByTheEconomy";
import Gold from './gold';
import {canHydrateByType} from "../../../../../services/training/snapshot";

const useStyles = makeStyles((theme) => ({
  submit: {
    transition: '1s all',
    '&:hover': {transform: "scale(1)"},
  },
  grid_container: {
    marginTop: theme.spacing(1.5),
  },
}));

const initialFValues = {
  typeTraining: "",
};

const TRAINING_OPTIONS = [
  {title: 'на условиях целевой подготовки (с 27.06 по 02.07)', id: 'targetTraining', disabled: true},
  {title: 'как победитель университетской олимпиады (с 27.06 по 01.07)', id: 'olympiad', disabled: true},
  {title: 'на общих основаниях', id: 'generalBasisWithoutPrivileges', disabled: false},
  {title: 'без экзаменов, как выпускник профильных классов', id: 'pedagogicalSpecialties', disabled: false},
  {title: 'без экзаменов на востребованные экономикой специальности', id: 'specialtiesByTheEconomy', disabled: false},
  {title: 'без экзаменов как обладатель аттестата особого образца или диплома с отличием', id: 'gold', disabled: false},
  // {title: 'на иных условиях', id: 'generalBasis', disabled: true},
];

const TRAINING_TYPES_FOR_REQUEST = [
  TRAINING_TYPE,
  TRAINING_STUDY_FORM,
  TRAINING_STUDY_PAY,
  TRAINING_FACULTY,
  TRAINING_SPECIALITIES_GROUP,
  TRAINING_ALLOW_FOR_PAID,
  TRAINING_SPECIALITY_BUDGET,
  TRAINING_SPECIALITY_PAID,
  TRAINING_TARGET_RECRUITMENT,
  TRAINING_TARGET_RECRUITMENT_SPEC,
];

const TRAINING_COMPONENT_BY_TYPE = {
  generalBasis: GeneralBasis,
  generalBasisWithoutPrivileges: GeneralBasis,
  targetTraining: TargetTraining,
  olympiad: Olympiad,
  specialtiesByTheEconomy: SpecialtiesByTheEconomy,
  pedagogicalSpecialties: PedagogicalSpecialties,
  gold: Gold,
};

const buildTrainingParams = () => TRAINING_TYPES_FOR_REQUEST.map((type) => `type[]=${type}`).join('&');

const Training = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [dataFromApi, setDataFromApi] = useState([]);

  const getTypeTraining = (item) => {
    const typeTraining = item.find(data => data.typeTitle === TRAINING_TYPE);
    return (typeTraining !== undefined ? typeTraining.value.value : '');
  }

  const validate = (fieldValues = values) => {
    let temp = {...errors};
    if ('typeTraining' in fieldValues) {
      temp.typeTraining = Valid.isIsset(fieldValues.typeTraining)
        ? ''
        : 'Это поле обязательное для заполнения!';
    }
    setErrors({...temp});
    if (fieldValues === values) {
      return Object.values(temp).every(x => x === '')
    }
  };

  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInputChange,
  } = useForm(initialFValues, true, validate);

  useEffect(() => {
    let isMounted = true;

    const getDataTraining = async () => {
      const result = await dispatch(getDataStatement(buildTrainingParams()));
      if (!isMounted) return;

      const preparedResult = Array.isArray(result) ? result : [];
      setDataFromApi(preparedResult);
      setValues((prevValues) => ({
        ...prevValues,
        typeTraining: getTypeTraining(preparedResult),
      }));
    };

    getDataTraining();

    return () => {
      isMounted = false;
      setValues((prevValues) => ({
        ...prevValues,
        typeTraining: '',
      }));
    };
  }, [dispatch, setValues]);

  const ActiveTrainingComponent = useMemo(
    () => TRAINING_COMPONENT_BY_TYPE[values.typeTraining] || null,
    [values.typeTraining],
  );
  const canHydrate = useMemo(
    () => canHydrateByType(dataFromApi, values.typeTraining),
    [dataFromApi, values.typeTraining],
  );

  return (
    <Container maxWidth="md">
      <Grid container spacing={2} justifyContent="center" className={classes.grid_container}>
        <Grid item md={12} xs={12}>
          <Card>
            <CardHeader title="Выбор специальности"/>
            <Divider/>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Controls.Select
                    fullWidth
                    name='typeTraining'
                    label={"Я буду подавать документы*"}
                    value={values.typeTraining}
                    options={TRAINING_OPTIONS}
                    onChange={handleInputChange}
                    error={errors.typeTraining}
                  />
                </Grid>
                {ActiveTrainingComponent ?
                  <Grid item xs={12} key={values.typeTraining}>
                    <ActiveTrainingComponent
                      typeTraining={values.typeTraining}
                      trainingSnapshot={dataFromApi}
                      canHydrate={canHydrate}
                    />
                  </Grid>
                  : null
                }
              </Grid>
            </CardContent>
          </Card>

        </Grid>
      </Grid>
    </Container>
  )
};

export default Training;